import React from 'react';
import { Infinity, CalendarDays } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const DAY_PRESETS = [30, 90, 180, 365];

export const inferPlusDurationFromUser = (user) => {
  if (!user || user.role !== 'plus') {
    return { plusDurationType: 'days', plusDurationDays: 30 };
  }
  if (!user.plusExpiryDate) {
    return { plusDurationType: 'lifetime', plusDurationDays: 30 };
  }
  const msLeft = new Date(user.plusExpiryDate).getTime() - Date.now();
  const daysLeft = Math.max(1, Math.ceil(msLeft / (1000 * 60 * 60 * 24)));
  return { plusDurationType: 'days', plusDurationDays: daysLeft };
};

const PlusDurationFields = ({ plusDurationType, setPlusDurationType, plusDurationDays, setPlusDurationDays }) => {
  const { t } = useTranslation('admin');
  return (
  <div className="space-y-3 rounded-xl border border-amber-500/20 bg-amber-500/5 p-4">
    <p className="text-xs font-semibold uppercase tracking-wide text-amber-400/90">{t('plusDurationFields.title')}</p>
    <div className="grid grid-cols-2 gap-2">
      <button
        type="button"
        onClick={() => setPlusDurationType('days')}
        className={`flex items-center justify-center gap-2 rounded-xl border px-3 py-2.5 text-sm font-medium transition-colors ${
          plusDurationType === 'days'
            ? 'border-amber-400/50 bg-amber-500/15 text-amber-300'
            : 'border-white/[0.08] bg-[#161f31] text-[#8aaccc] hover:bg-white/[0.04]'
        }`}
      >
        <CalendarDays className="h-4 w-4" />
        {t('plusDurationFields.timed')}
      </button>
      <button
        type="button"
        onClick={() => setPlusDurationType('lifetime')}
        className={`flex items-center justify-center gap-2 rounded-xl border px-3 py-2.5 text-sm font-medium transition-colors ${
          plusDurationType === 'lifetime'
            ? 'border-amber-400/50 bg-amber-500/15 text-amber-300'
            : 'border-white/[0.08] bg-[#161f31] text-[#8aaccc] hover:bg-white/[0.04]'
        }`}
      >
        <Infinity className="h-4 w-4" />
        {t('plusDurationFields.lifetime')}
      </button>
    </div>

    {plusDurationType === 'days' && (
      <div className="space-y-2">
        <label className="block text-sm text-[#8aaccc]">{t('plusDurationFields.daysCountLabel')}</label>
        <input
          type="number"
          min={1}
          max={3650}
          value={plusDurationDays}
          onChange={(e) => setPlusDurationDays(Math.max(1, parseInt(e.target.value, 10) || 1))}
          className="w-full rounded-xl border border-white/[0.08] bg-[#161f31] px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-amber-400/30"
        />
        <div className="flex flex-wrap gap-1.5">
          {DAY_PRESETS.map((days) => (
            <button
              key={days}
              type="button"
              onClick={() => setPlusDurationDays(days)}
              className={`rounded-lg px-2.5 py-1 text-xs font-medium transition-colors ${
                plusDurationDays === days
                  ? 'bg-amber-500/20 text-amber-300 border border-amber-400/30'
                  : 'bg-white/[0.04] text-[#7a96b0] hover:bg-white/[0.07]'
              }`}
            >
              {t('plusDurationFields.daysSuffix', { count: days })}
            </button>
          ))}
        </div>
      </div>
    )}
  </div>
  );
};

export default PlusDurationFields;
